import { useEffect, useRef } from "react";

const Cursor = () => {
  const blobRef = useRef(null);
  const positionRef = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 }); // Initial center
  const targetRef = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 }); // Target (cursor)

  useEffect(() => {
    const handlePointerMove = (e) => {
      const { clientX, clientY } = e;
      targetRef.current = { x: clientX, y: clientY };
    };

    const animate = () => {
      if (blobRef.current) {
        const { x: targetX, y: targetY } = targetRef.current;
        const { x: currentX, y: currentY } = positionRef.current;

        // Lerp for smooth movement
        const lerpFactor = 0.05; // Adjust for speed
        const newX = currentX + (targetX - currentX) * lerpFactor;
        const newY = currentY + (targetY - currentY) * lerpFactor;

        positionRef.current = { x: newX, y: newY };

        // Adjust for blob size (650px) to center it on the cursor
        const blobWidth = 650; // Match CSS width
        const blobHeight = 650; // Match CSS height
        blobRef.current.style.left = `${newX - blobWidth / 2}px`;
        blobRef.current.style.top = `${newY - blobHeight / 2}px`;

        requestAnimationFrame(animate);
      }
    };

    document.addEventListener("pointermove", handlePointerMove);
    requestAnimationFrame(animate);

    return () => {
      document.removeEventListener("pointermove", handlePointerMove);
    };
  }, []);

  return (
    <>
      <div id="blob" ref={blobRef}></div>
      <div id="blurcursor"></div>
    </>
  );
};

export default Cursor;